import {
    getProduct,
    listProductLineItems
} from './queries';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateProductLineItem,
    DeleteProductLineItem,
    GetProductLineItem,
    ListProductLineItems,
    ProductLineItem,
    UpdateProductLineItem
} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {
    createProductLineItem,
    deleteProductLineItem,
    updateProductLineItem
} from "./mutations.ts";
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;


export const fetchRecords = async (query: ListRecordsQuery & { productId: string }) => {
    const response = await client.graphql<GraphQLQuery<ListProductLineItems>>({
        query: listProductLineItems,
        variables: {
            productId: query.productId,
            limit: query.limit,
            sort: query.sort,
            nextToken: query.nextToken
        }
    });

    return {
        items: response.data?.listProductLineItems.items,
        nextToken: response.data?.listProductLineItems.nextToken
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetProductLineItem>>({
                                                                                query: getProduct,
                                                                                variables: {id: id},
                                                                            });
    return response.data?.getProductLineItem;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateProductLineItem>>({
                                                                                   query: createProductLineItem,
                                                                                   variables: {input: payload},
                                                                               });
    console.debug('in the service response', response);
    return response.data?.createProductLineItem;
};

export const update = async (id: string, record: ProductLineItem) => {

    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateProductLineItem>>({
                                                                                   query: (updateProductLineItem),
                                                                                   variables: {input: record},
                                                                               });
    return response.data?.updateProductLineItem;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteProductLineItem>>({
                                                                                   query: (deleteProductLineItem),
                                                                                   variables: {input: {id: id}},

                                                                               });
    return response.data?.deleteProductLineItem;
};
